import { render, staticRenderFns } from "./Detail-Project.vue?vue&type=template&id=4c32d036"
import script from "./Detail-Project.vue?vue&type=script&lang=js"
export * from "./Detail-Project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports